<template>
  <div>
    <div
      class="card-container"
      :style="bg_color ? { backgroundColor: bg_color } : null"
    >
      <div class="row-div" v-if="!hide_title">
        <div class="row-info-div">
          <div class="title-div">
            <slot name="title"></slot>
          </div>
        </div>
      </div>
      <div class="card-body">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // Oculta el encabezado de la tarjeta (cuando el título lo provee otro
    // contenedor, p. ej. una pestaña del dashboard).
    hide_title: {
      type: Boolean,
      default: false,
    },
    // Color de fondo de la tarjeta (ej. "#e0f1ff"). Si es null, queda transparente.
    bg_color: {
      type: String,
      default: null,
    },
  },
};
</script>
<style scoped>
.card-container {
  width: 100%;
  height: 100%;
  background-color: transparent;
  padding: 0;
  border: 1px solid #c7d1dd !important;
  display: flex;
  flex-direction: column;
  border-radius: 10px !important;
}
.card-body {
  padding: 0.7rem;
  border-bottom-left-radius: 7px !important;
  border-bottom-right-radius: 7px !important;
}
.row-div {
  /* display: flex; */
  flex-direction: row;
  flex-wrap: wrap;
}
.row-info-div {
  width: 100%;
  /* display: flex; 
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start; */
}
.title-div {
  width: 100%;
  padding: 0.4rem 0.5rem !important;
  font-weight: bold;
  text-align: left;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
</style>